import { CommonModule } from '@angular/common';
import { Component, ElementRef, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { paymentSourceType, SharedService } from 'src/app/services/shared.service';
import { GenerateStripeElementComponent } from '../generate-stripe-element/generate-stripe-element.component';
import { localStorageService } from 'src/app/services/localstorage.service';

@Component({
  selector: 'app-existing-payment-sources',
  standalone: true,
  imports: [FormsModule, CommonModule],
  templateUrl: './existing-payment-sources.component.html',
  styleUrl: './existing-payment-sources.component.scss'
})
export class ExistingPaymentSourcesComponent {

  @ViewChild('cardListWrapper') cardListWrapper!: ElementRef;
  extra_data!: extra_data;
  doctor_profile: any = {};
  isSelectionSubmitted = false;

  constructor(public bsModalRef: BsModalRef, private _shared: SharedService, private _modal: BsModalService, private _local: localStorageService) {
    this.doctor_profile = this._local.customGetItem('userProfileData');
  }

  modalHide(resetSelectionState = true) {
    if (resetSelectionState) {
      this.isSelectionSubmitted = false;
    }
    this.bsModalRef.hide();
  }

  selectCard(card: any) {
    this.extra_data.selectedCard = card;
  }

  addCardModal() {
    if (this.extra_data.payment_type === 'share_link' && this.extra_data.onAddCard) {
      this.bsModalRef.hide();
      this.extra_data.onAddCard();
      return;
    }

    const modalRef = this._modal.show(GenerateStripeElementComponent, {
      initialState: {
        stripeData: {
          doctor_profile: this.doctor_profile,
          patient_profile: this.extra_data.patient_profile,
          payment_source_type: this.extra_data.payment_source_type,
          payment_mode: this.extra_data.payment_mode,
          minHeight: this.cardListWrapper.nativeElement.offsetHeight,
          payment_type: this.extra_data.payment_type,
          captcha: this.extra_data.captcha,
          doctor_id: this.extra_data.doctor_id,
        }
      }
    })

    modalRef.content?.sendPaymentSourceData.subscribe((response) => {
      if (response.success) {
        this.extra_data.selectedCard = response.selectedCard?.data || response.selectedCard;
        this.isSelectionSubmitted = true;
        modalRef.hide();
        this.modalHide(false);
      }
    })
  }

  changeSelectedCard() {
    if (!this.extra_data.selectedCard || (this.extra_data.selectedCard && !this.extra_data.selectedCard.source_id)) {
      this._shared.customPopups('Please select a card', 1);
      return;
    }
    this.isSelectionSubmitted = true;
    this.modalHide(false);
  }

  getCardHolderName(card?: any) {
    const cardHolderName = card?.name || card?.card_holder_name || card?.cardholder_name;
    if (cardHolderName) {
      return String(cardHolderName);
    }

    const holder = this.extra_data?.patient_profile;
    if (holder && typeof holder === 'object') {
      const firstName = holder.patient_first_name || holder.first_name || holder.doctor_first_name || '';
      const lastName = holder.patient_last_name || holder.last_name || holder.doctor_last_name || '';
      const fullName = `${firstName} ${lastName}`.trim();
      if (fullName) {
        return fullName;
      }
      return holder.doctor_name || holder.patient_name || holder.business_name || '';
    }
    if (typeof holder === 'string') {
      return holder;
    }
    return 'Saved Card';
  }

  getCardBrandImage(card: any) {
    const brand = String(card?.brand || card?.card_brand || card?.network || '').toLowerCase();
    if (brand.includes('visa')) {
      return 'assets/images/img/visa-card-imgage.png';
    }
    if (brand.includes('master')) {
      return 'assets/images/img/mastercard-image.png';
    }
    if (brand.includes('amex') || brand.includes('american')) {
      return 'assets/images/img/amex-card-image.png';
    }
    return 'assets/images/img/dummy-card-image.png';
  }

  useFallbackCardImage(event: Event) {
    const img = event.target as HTMLImageElement | null;
    if (img) {
      img.src = 'assets/images/img/dummy-card-image.png';
    }
  }
}

interface extra_data {
  selectedCard?: paymentSourceType;
  cards_list?: paymentSourceType[];
  patient_profile?: any,
  payment_source_type: number,
  payment_mode: number,
  paymentType?: string,
  payment_type?: string,
  captcha?: string,
  doctor_id?: number,
  onAddCard?: () => void,
}
